module.exports = __webpack_public_path__ + "img/2.c4ce3e04.jpg";